<template>
  <span>
    <span v-if="totalHits">
      Showing {{ firstHitOnPage }}-{{ lastHitOnPage }} of {{ totalHits }} results</span
    >
    <span v-else>0 results</span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["firstHitOnPage", "lastHitOnPage", "query", "totalHits"]),
  },
};
</script>
